import {
  GET_ALL_CITY,
  GET_CITY,
  GET_BLOCK_CITY
} from 'src/store/mutation-types'
export default {
  [GET_ALL_CITY] (state, cities) {
    state.cities = cities
  },
  [GET_CITY] (state, city) {
    state.city = city
  },
  [GET_BLOCK_CITY] (state, cities) {
    state.blockCities = cities
  }
}



// WEBPACK FOOTER //
// ./src/components/city/store/mutations.js